import api from "@/utils/api";

export const getBasicStats = async () => {
    const response = await api.req({
        url: "/dashboard/stats",
        method: api.Method.GET,
    })
    return response;
}

export const getDailyTrends = async (startDate: string, endDate: string) => {
    const response = await api.req({
        url: `/dashboard/daily-stats?start_date=${startDate}&end_date=${endDate}`,
        method: api.Method.GET,
    })
    return response;
}

export const getMonthlyStats = async (monthlyPeriod: string) => {
    const response = await api.req({
        url: `/dashboard/monthly-stats?months=${monthlyPeriod}`,
        method: api.Method.GET,
    })
    return response;
}

export const getSourceStats = async (queryParams: string) => {
    const response = await api.req({
        url: `/dashboard/sources/${queryParams}`,
        method: api.Method.GET,
    })
    return response;
}

export const getStatusStats = async (queryParams: string) => {
    const response = await api.req({
        url: `/dashboard/status/${queryParams}`,
        method: api.Method.GET,
    })
    return response;
}